import './SearchTabsHeader.scss'

import { TabType } from '@react/SearchResults/SearchTypes'
import { cls } from '@react/utils/classname'
import { ReactElement } from 'react'

type SearchTabsHeaderProps = {
  selectedIndex: number
  tabsArray: TabType[]
  selectTab: (i: number, event) => void
}

export function SearchTabsHeader({ tabsArray, selectedIndex, selectTab }: SearchTabsHeaderProps): ReactElement {
  const isAllTabsEmpty = tabsArray.every((tab: TabType) => !tab?.resultsTotal)

  return (
    <div className="saas-search-results-cmp-header" data-testid="search-tabs-header">
      <div className={cls({ 'saas-search-results-cmp-header__tabs': true, 'saas-search-results-cmp-header__tabs--is-hidden': isAllTabsEmpty })}>
        <ul role="tablist" aria-multiselectable="false" data-testid="tabs-header">
          {tabsArray.map(
            (tab: TabType, index) =>
              !!tab.resultsTotal && (
                <li
                  key={`${tab.tabId}_tab`}
                  data-id={tab.tabId}
                  data-dm={`searchresult-tabs. ${tab.title.toLowerCase()}`}
                  className={cls({
                    'saas-search-results-cmp-header__tab': true,
                    'saas-search-results-cmp-header__tab--is-active': index === selectedIndex,
                    'saas-search-results-cmp-header__tab--is-hidden': !tab.isVisible,
                  })}
                  role="tab"
                  aria-selected={index === selectedIndex ? 'true' : 'false'}
                  onClick={event => selectTab(index, event)}
                  onKeyDown={event => selectTab(index, event)}
                  data-testid="tab-title"
                >
                  {tab.title} ({tab.resultsTotal})
                </li>
              ),
          )}
        </ul>
      </div>
    </div>
  )
}
